import { FC } from 'react';

import { DeleteConfirmation } from './delete-confirmation';
import { ViewerImageType } from './image-viewer';
import { ImageViewerNavigation as Navigation } from './navigation';
import { Buttons } from '../images-gallery/buttons';

interface ImageViewerToolBarProps {
  images: ViewerImageType[];
  currentImageIndex: number;
  setCurrentImageIndex: (index: number) => void;
  selectedImage: ViewerImageType;
  onSetMainImage?: (imageId: string) => void;
  onDeleteImage: () => void;
  showDeleteConfirmation: boolean;
  setShowDeleteConfirmation: (show: boolean) => void;
}

export const ImageViewerToolBar: FC<ImageViewerToolBarProps> = ({
  images,
  currentImageIndex,
  setCurrentImageIndex,
  selectedImage,
  onSetMainImage,
  onDeleteImage,
  showDeleteConfirmation,
  setShowDeleteConfirmation,
}) => {
  return showDeleteConfirmation ? (
    <DeleteConfirmation
      className="miniTablet:flex-row miniTablet:items-center"
      fullWidthButtons={true}
      onDeleteImage={onDeleteImage}
      setShowDeleteConfirmation={setShowDeleteConfirmation}
    />
  ) : (
    <div className="flex flex-col items-end justify-between gap-6 miniTablet:flex-row miniTablet:items-center min-h-[4rem]">
      <Buttons
        className="w-full flex-col gap-y-4 miniTablet:flex-row"
        selectedImage={selectedImage}
        onSetMainImage={onSetMainImage}
        showMainImageButton={images.length > 1 && !!onSetMainImage}
        setShowDeleteConfirmation={setShowDeleteConfirmation}
        inModal={true}
      />
      <Navigation currentImageIndex={currentImageIndex} setCurrentImageIndex={setCurrentImageIndex} imagesCount={images.length} />
    </div>
  );
};
